import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import { setSelectedFilterOptions } from 'src/store/placementOverviewPageSlice';
import { useAppSelector } from 'src/store/store';
import { createSearchRegExp } from 'src/utils/searchUtils';

const MultipleShiftDropdown = () => {
  const dispatch = useDispatch();

  const { availableFilterOptions, selectedFilterOptions } = useAppSelector((state) => state.placementOverviewPage);
  const allShifts = availableFilterOptions.availableShiftCodes;

  const [searchQuery, setSearchQuery] = useState();
  const searchRegExp = createSearchRegExp(searchQuery);

  const matchedShiftCodeOptions = allShifts.filter((shiftCode: string) => !searchQuery || searchRegExp.test(shiftCode));

  return (
    <Column spacing="100">
      <Text>Shift</Text>
      <Select
        size="small"
        value={selectedFilterOptions.shiftCodes}
        onChange={(newValue) => {
          dispatch(setSelectedFilterOptions({ ...selectedFilterOptions, shiftCodes: newValue }));
        }}
        searchQuery={searchQuery}
        onSearch={setSearchQuery}
        placeholder="Enter value..."
      >
        {matchedShiftCodeOptions.map((shiftCode: string) => (
          <SelectOption label={shiftCode} value={shiftCode} key={shiftCode} />
        ))}
        {!matchedShiftCodeOptions.length ? (
          <Column alignmentVertical="center" spacing="300" spacingInset="500">
            <Text alignment="center">No results</Text>
          </Column>
        ) : null}
      </Select>
    </Column>
  );
};

export default MultipleShiftDropdown;
